module.exports = __webpack_public_path__ + "img/bg_function02_1_t.74af17c0.png";